import Icon from 'semantic-ui-react/dist/commonjs/elements/Icon';
import '@purple/semantic-ui-purple-theme/components/icon.css';

export default Icon;
